import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { Button, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  mainButton: {
    ...theme.buttons.mainBtn,
    borderRadius: 0,
    padding: '6px 32px',
    '&:hover': {
      ...theme.buttons.mainBtnHover,
      cursor: 'pointer',
    },
    '@media (hover: none)': {
      '&:hover': {
        ...theme.buttons.mainBtn,
        opacity: 1,
      },
    },
  },
  mainButtonLabel: {
    color: 'white',
    fontSize: 15,
    fontWeight: 'bold',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      whiteSpace: 'normal',
    },
  },
  contentText: {
    color: 'inherit',
  },
  dialog: {
    '& .MuiDialog-paper': {
      maxWidth: '536px !important',
    },
  },
}));

export const FeedbackSuccessDialog = () => {
  const [open, setOpen] = useState(true);

  const onOkClick = () => setOpen(false);

  const classes = useStyles();

  return (
    <CustomDialog
      open={open}
      aria-labelledby="feedback-dialog-title"
      aria-describedby="feedback-dialog-description"
      dialogTitle={t('startWarningDialog.title')}
      onCancel={onOkClick}
      className={classes.dialog}
    >
      <DialogContent>
        <DialogContentText
          dangerouslySetInnerHTML={{ __html: t('startWarningDialog.content') }}
          className={classes.contentText}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onOkClick}
          classes={{
            root: classes.mainButton,
            label: classes.mainButtonLabel,
          }}
        >
          {t('startWarningDialog.okButtonLabel')}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default FeedbackSuccessDialog;
